import {AxiosError} from 'axios';
import {useQueryClient} from 'react-query';
import {CoordinatorProfileRequest} from '../../api/user/model';
import {PUT_UPDATE_COORDINATOR_PROFILE_URL} from '../../constants/apiUrls';
import {GET_COORDINATOR_PROFILE_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutUpdateCoordinatorProfile = ({onSuccess, onError}: Input = {}) => {
  const queryClient = useQueryClient();

  const putUpdateCoordinatorProfile = async (reqBody: CoordinatorProfileRequest) => {
    await axiosClient.put<void>(PUT_UPDATE_COORDINATOR_PROFILE_URL, reqBody);
  };

  return useCustomMutation(
      putUpdateCoordinatorProfile,
      {
        onSuccess: () => {
          queryClient.invalidateQueries(GET_COORDINATOR_PROFILE_QUERY_KEY);
          onSuccess?.();
        },
        onError,
      },
      false
  );
};
